import { FLEX } from "common/utils";
import styled from "styled-components";

export const FormWrapper = styled.form`
width: 100%;
${FLEX({ direction: "column" })};
gap:24px;
@media screen and (min-width: 450px)and (max-width: 999px) {
    justify-content:center;
    align-items: center;
    max-width:450px;
    margin:0 auto;
}
`

export const InputBoxWrapper = styled.div`
width: 100%;
display:flex;
flex-direction:column;
gap:24px;
@media screen and (min-width: 1000px){
    flex-direction:row;
    align-items: center;
}
`
export const TextareaBoxWrapper = styled.div`
width:100%;
height:93px;
margin-bottom:8px;
@media screen and (min-width: 1000px){
    height:177px;
}
`
